import React, {memo} from "react";
import {CustomSocket} from "./CustomSocket";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-left: auto;
  position: relative;
`;

const StyledRemoveButtonControlWrapperDiv = styled.div`
  position: absolute;
  top: -36px;
  right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledImageControlsSocketContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledImageControlsContainerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledImageFileControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  width: 100%;
  > div {
      width: 100% !important;
      flex: 1 !important;
  }
`;

const StyledDurationControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-top: 16px;
  > div {
      width: 100% !important;
      flex: 1 !important;
  }
`;

const StyledSocketContainerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  width: 0px;
`;

const Image = ({node, controls, output, bindSocket, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    const hasAnswer = SequenceComponentHelper.hasAnswer(node);
    const imageUUID = output.key.split("_")[0];
    const removeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getImageRemoveButtonKey(imageUUID)));
    const imageFileControl = controls.find(control => control.key.includes(SequenceComponentHelper.getImageFileKey(imageUUID)));
    const durationControl = controls.find(control => control.key.includes(SequenceComponentHelper.getImageDurationKey(imageUUID)));

    return (
        <>

            {/** NESTED NODE - IMAGE */}
            <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                {/** REMOVE BTN */}
                {!isNodeCollapsed &&
                    <StyledRemoveButtonContainerDiv>
                        <StyledRemoveButtonControlWrapperDiv>
                            <Control key={removeControl.key} control={removeControl} innerRef={bindControl}/>
                        </StyledRemoveButtonControlWrapperDiv>
                    </StyledRemoveButtonContainerDiv>
                }

                {/** IMAGE CONTROLS & SOCKET */}
                <StyledImageControlsSocketContainerDiv>

                    {/** IMAGE CONTROLS */}
                    <StyledImageControlsContainerDiv>
                        <StyledImageFileControlContainerDiv>
                            <Control key={imageFileControl.key} control={imageFileControl} innerRef={bindControl}/>
                        </StyledImageFileControlContainerDiv>

                        {!isNodeCollapsed &&
                            <StyledDurationControlContainerDiv>
                                <Control key={durationControl.key} control={durationControl} innerRef={bindControl}/>
                            </StyledDurationControlContainerDiv>
                        }

                    </StyledImageControlsContainerDiv>

                    {/** SOCKET */}
                    <StyledSocketContainerDiv>
                        {output && !hasAnswer &&
                            <CustomSocket type="output" socket={output.socket}
                                          io={output} innerRef={bindSocket}/>
                        }
                    </StyledSocketContainerDiv>
                </StyledImageControlsSocketContainerDiv>
            </StyledNestedNodeDiv>
        </>
    );
}

export default memo(Image);